import GenericTable from "../../components/Table/GenericTable";
import React from "react";

const tableStructure = [
  {
    header: "Imię",
    field: "first_name",
    accessor: "user__first_name",
    className: "w-2",
    sort: true
  },
  {
    header: "Nazwisko",
    field: "last_name",
    accessor: "user__last_name",
    className: "w-3",
    sort: true
  },
  {
    header: "Nazwa użytkownika",
    field: "username",
    accessor: "user__username",
    className: "w-3",
    sort: true
  },
  {
    header: "Biblioteka",
    field: "library.name",
    accessor: "library__name",
    className: "w-2",
    sort: true,
    url: "/library/<id>/preview/"
  },
  {
    header: "Akcje",
    className: "w-2 has-text-right"
  }
];

const urls = {
  get: "/api/users/workers/",
  add: "/users/worker/create/",
  edit: "/users/worker/", //appends /${id}/update
  delete: "/api/users/workers/" //appends /${id}/
};

const messages = {
  deleteSuccess: "Redaktor został poprawnie usunięty",
  deleteError: "Wystąpił problem podczas usuwania redaktora",
  btnAdd: "Dodaj użytkownika",
  btnDeleteNo: "Anuluj",
  btnDeleteYes: "Usuń",
  headerTitle: "Potwierdzenie usunięcia",
  bodyContent: "Czy na pewno chcesz usunąć redaktora?",
  contentLabel: "Potwierdzenie usunięcia redaktora"
};

const Workers = ({ message, hasCreatePermission }) => {
  return (
    <section className="mbc-backoffice">
      <div className="container">
        <div className="breadcrumbs">
          <a
            href="/admin-panel/home/"
            className="breadcrumbs__link"
            title="Strona główna"
          >
            Strona główna
          </a>
          &nbsp;/&nbsp;
          <strong>Użytkownicy wewnętrzni</strong>
        </div>
        <GenericTable
          structure={tableStructure}
          notification={message}
          messages={messages}
          urls={urls}
          deleteItemName="username"
          disablePreview={false}
          hasHeaderActions={hasCreatePermission}
        />
      </div>
    </section>
  );
};

export default Workers;
